import { api } from "@/redux/api";

import {
	CreateReviewSessionRequest,
	CreateReviewSessionRequestSchema,
	ReviewSession,
	ReviewSessionSchema,
} from "./reviewSession.schema";

export const reviewSessionApi = api.injectEndpoints({
	endpoints: (builder) => ({
		createReviewSession: builder.mutation<ReviewSession, CreateReviewSessionRequest>({
			query: (body) => ({
				url: "list/review-sessions",
				method: "POST",
				body,
				requestSchema: CreateReviewSessionRequestSchema,
				responseSchema: ReviewSessionSchema,
			}),
			invalidatesTags: ["ReviewSession"],
		}),
		getReviewSession: builder.query<ReviewSession, string>({
			query: (id) => ({
				url: `list/review-sessions/${id}`,
				responseSchema: ReviewSessionSchema,
			}),
			providesTags: (_result, _err, id) => [{ type: "ReviewSession", id }],
		}),
	}),
});

export const {
	useCreateReviewSessionMutation,
	useGetReviewSessionQuery,
	useLazyGetReviewSessionQuery,
} = reviewSessionApi;
